import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { IoInformationCircleSharp } from "react-icons/io5";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import {
  deleteTransferCart,
  getAllTransferCartDetails,
} from "./services/transferSearch.services";
import AlertBox from "../../components/common/AlertBox";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  clearTransferSearchID,
  setTransferSearchID,
} from "./transferSearchSlice";
import RippleButton from "../../components/common/RippleButton";
import { useNavigate } from "react-router-dom";

const TransferCart: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllTransferCartDetails());
  }, []);
  return (
    <>
      <DeleteTransferCartDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
            
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Your Cart
          </Typography.h4>
          <div>
            <Button
              type="button"
              fillMode={"outline"}
              themeColor={"primary"}
              style={{ marginRight: 4 }}
              onClick={() => navigate(-1)}
            >
              Previous
            </Button>
            <RippleButton onClick={() => navigate("/transfercustomerdetails")}>
              Proceed Booking
            </RippleButton>
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <CartGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const CartGridComponent: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const TransferCartList = useAppSelector(
    (state: RootState) => state.transferSearch.TransferCartList
  );
  const loading = useAppSelector(
    (state: RootState) => state.transferSearch.loading
  );

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteTransferCart"));
      dispatch(setTransferSearchID(ID));
    };

    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
        >
          <MdDelete
            className="absolute-position"
            style={{ fontSize: "24px" }}
          />
        </IconButton>
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {TransferCartList && TransferCartList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 200px)" }}
          data={TransferCartList}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column field="FromLocation" title="Pick Up Place" />
          <Column field="ToLocation" title="Drop Place" />
          <Column field="VehicleType" title="Vehicle" />
          <Column field="Pax" title="No Of Pax" />
          <Column field="Rate" title="Cost" />
          <Column
            field="ID"
            title="Actions"
            cell={MyEditCommandCell}
            width={"110px"}
            filterable={false}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
      <div style={{ display: "flex", margin: "20px 0" }}>
        <div className="termsAndCondition" style={{ width: "50%" }}></div>
        <div style={{ width: "50%" }}>
          <table style={{ width: "100%" }} className="cartTable">
            <tr>
              <th>Total Price</th>
              <td>{TransferCartList[0]?.TotalRate || 0}</td>
            </tr>
            <tr>
              <th>
                Transaction Charges{" "}
                <IoInformationCircleSharp style={{ fontSize: "20px" }} />
              </th>
              <td>{TransferCartList[0]?.TransectionCharges || 0}</td>
            </tr>
            <tr>
              <th>Grand Total</th>
              <td>{TransferCartList[0]?.GrandTotal || 0}</td>
            </tr>
          </table>
        </div>
      </div>
    </>
  );
};

const DeleteTransferCartDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const TransferSearchID = useAppSelector(
    (state: RootState) => state.transferSearch.TransferSearchID
  );
  const dialogName = useAppSelector(
    (state: RootState) => state.dialog.dialogName
  );
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteTransferCart(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllTransferCartDetails());
        dispatch(closeDialog());
        dispatch(clearTransferSearchID());
      } else {
        dispatch(getAllTransferCartDetails());
        dispatch(closeDialog());
        dispatch(clearTransferSearchID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteTransferCart" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete From Cart?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TransferSearchID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default TransferCart;
